import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, BarChart3, PieChart } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide11Measurement({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-69">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-70">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-71">
          Measurement Framework
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-72">
          Better engagement,{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-73">
            not just more clicks.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-5 flex flex-col justify-center gap-6" data-id="element-75">
          <p className="text-[var(--fg)] text-[clamp(1.1rem,1.5vw,1.5rem)] font-medium leading-relaxed" data-id="element-76">
            The KPI goal is not only to increase page views, but to improve the
            conversion from awareness to meaningful engagement.
          </p>
          <div className="bg-[var(--brand-green)] text-white p-8 rounded-2xl shadow-lg" data-id="element-77">
            <p className="font-bold text-xl leading-snug" data-id="element-78">
              Snakker helps reveal not only whether HCPs clicked, but why they
              engaged, where they hesitated, and which message moved them
              forward.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-7 bg-[var(--surface)] rounded-2xl p-8 border border-black/5 flex flex-col" data-id="element-79">
          <div className="flex items-center gap-3 mb-6" data-id="element-80">
            <LineChart className="w-6 h-6 text-[var(--brand-green)]" data-id="element-81" />
            <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-82">
              What we track
            </h3>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-4 flex-1 content-start" data-id="element-83">
            {['Impressions to Snak starts', 'Snak starts to completed engagement', 'Unique engaged HCPs', 'Bounce rate', 'Average view time', 'Cue responses', 'Barrier selections', 'CTA clicks', 'CTR', 'Drop-off points', 'High-value actions', 'Repeat engagement', 'Most engaging campaign themes', 'Best-performing hooks', 'Best-performing CTAs'].map((metric, i) => <div key={i} className="flex items-center gap-2 text-[var(--muted)] font-medium text-sm" data-id="element-84">
                <div className="w-1.5 h-1.5 rounded-full bg-[var(--brand-green)]" data-id="element-85" />
                {metric}
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}